import React from "react";

function Blog(props) {
  return (
    <div>
      <p>Hey blog</p>
    </div>
  );
}

export default Blog;
